import axios from 'axios';
import dotenv from 'dotenv';

dotenv.config();

const { REACT_APP_SNS_BASE_URL } = process.env;

const client = axios.create({
  baseURL: REACT_APP_SNS_BASE_URL,
});

// client.defaults.headers.common['Content-Type'] = 'application/json';
client.defaults.headers.post['Content-Type'] = 'application/json';

const setAuthToken = (token) => {
  client.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export const userAPI = {
  logIn: async (userData) => {
    const {
      data: { token, user },
    } = await client.post('/login', userData);
    setAuthToken(token);

    return { user, token };
  },
  logOut: async () => {
    await client.post('/logout');
  },
  signUp: async (userData) => {
    const { data } = await client.post('/signup', userData);

    return data;
  },
  getUser: async (token) => {
    setAuthToken(token);
    const { data } = await client.get('/auth-user');

    return data;
  },
  updatePassword: async (passwordData) => {
    const { data } = await client.put(
      '/settings/update-password',
      passwordData,
    );

    return data;
  },
  updateName: async (nameData) => {
    const { data } = await client.put('/settings/update-user', nameData);

    return data;
  },
  updateProfile: async (profileData) => {
    const { data } = await client.put('/users/upload-photo', profileData);

    return data;
  },
};

export const postAPI = {
  getPosts: async ({ offset, limit, channelId }) => {
    const { data } = await client.get(`/posts/channel/${channelId}`, {
      params: {
        offset,
        limit,
      },
    });
    return data;
  },
  getPost: async (postId) => {
    const { data } = await client.get(`/posts/${postId}`);
    return data;
  },
  getMyPosts: async (userId) => {
    const { data } = await client.get(`/posts/author/${userId}`);
    return data;
  },
  createLikedPost: async (postId) => {
    const { data } = await client.post('/likes/create', { postId });
    return data;
  },
  deleteLikedPost: async (likeId) => {
    await client.delete('/likes/delete', {
      data: { id: likeId },
    });
  },
  addPost: async (post) => {
    const { data } = await client.post('/posts/create', post);
    return data;
  },
  updatePost: async (post) => {
    const { data } = await client.put('/posts/update', post);

    return data;
  },
  deletePost: async (postId) => {
    const { data } = await client.delete('/posts/delete', {
      data: { id: postId },
    });

    return data;
  },
  createComment: async (commentData) => {
    const { data } = await client.post('/comments/create', commentData);

    return data;
  },
  deleteComment: async (commentId) => {
    const { data } = await client.delete('/comments/delete', {
      data: { id: commentId },
    });

    return data;
  },
};

export const notificationAPI = {
  createNotification: async (notificationData) => {
    const { data } = await client.post(
      '/notifications/create',
      notificationData,
    );

    return data;
  },
  getNotifications: async () => {
    const { data } = await client.get('/notifications');

    return data;
  },
  readAllNotifications: async () => {
    const { data } = await client.put('/notifications/seen');

    return data;
  },
};

export const channelAPI = {
  getChannelDetail: async (channelName) => {
    const { data } = await client.get(`/channels/${channelName}`);

    return data;
  },
};

// export const getRandomNickname = async (count) => {
//   const { data: words } = await axios.get(
//     `https://nickname.hwanmoo.kr/?format=json&count=${count}`,
//     null,
//     {
//       headers: {
//         'Content-Type': 'application/json',
//         'Access-Control-Allow-Origin': '*',
//       },
//     },
//   );

//   return words;
// };
